"use client"
import Badge from "~/componentsDS/Badge";
import { QuizCTA } from "~/components/features/quiz";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import InteractiveTimeline from "~/componentsDS/InteractiveTimeline";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import Reveal from "~/componentsDS/Reveal";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import useLpCtaText from "~/hooks/useLpCtaText";

const CTA_TITLE = "See If Oestra® Is Right for You";

const NoticeSection = () => {

    const ctaTitle = useLpCtaText(CTA_TITLE);

    return (
        <section className="pt-16 md:pt-12 pb-[44px] md:pb-[96px]">
            <ElementorContainer rowGap="16px" columnGap="16px" innerClassName="flex flex-col mb-[32px]">
                <Badge className="mb-0 font-medium w-fit text-[16px] font-suisseBP px-4 py-[7px] md:px-4 md:py-[5px]">Your journey</Badge>
                <Reveal>
                    <Heading
                        as="h2"
                        size="sm"
                        sizes={{ md: "md" }}
                        className="text-primary500 mb-0 md:mb-0 tracking-[-1.2px]"
                    >
                        Feel it week by{" "}
                        <Heading
                            as="i"
                            font="featureDisplay"
                            weight="400"
                            className="text-[28px] md:text-[36px]"
                        >
                        week
                        </Heading>

                    </Heading>
                </Reveal>
                <Paragraph size="lg" className="text-primary500">
                    Real changes. Backed by science. Felt by thousands of women.
                </Paragraph>
            </ElementorContainer>

            <InteractiveTimeline className="lg:max-w-[1920px] lg:px-0 min-[1025px]:px-12 min-[1280px]:px-16 min-[1440px]:px-20 min-[1728px]:px-[144px]" />

            <div className="hidden pt-8 md:flex justify-center">
                <QuizCTA
                    variant="primary"
                    eventData={{
                        event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                        widget: "lp_weeks_improvement",
                        meta_data: {
                            click_text: CTA_TITLE,
                        },
                    }}
                    href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                    size="md"
                >
                    <TextWithRegisteredMark text={ctaTitle} />
                </QuizCTA>
            </div>
        </section>
    );
};

export default NoticeSection;
